<template>
  <v-row align="center" class="ma-0 pa-0">
    <v-col cols="12" class="pa-0">
      <v-toolbar height="60" dark color="primary">
        <v-btn fab x-small color="white" depressed @click="onClose()">
          <v-icon class="primary--text">close</v-icon>
        </v-btn>
        <v-toolbar-title class="white--text pl-2">地図</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-col>
    <v-col cols="12" class="pa-0">
      <v-card flat>
        <v-card-text class="pa-0">
          <v-row class="ma-0 pa-0" align="center">
            <v-col cols="4" class="py-0">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="12" class="pa-0">
                  <v-toolbar flat class="b-B" height="40">
                    <v-toolbar-title class="text-left subheading">
                      <span>登録済み</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <div class='overflow-y-auto' :style="contentsHeight">
                    <RecycleScroller
                      class="scroller"
                      :items="locations"
                      :item-size="44"
                      key-field="key"
                    >
                      <template v-slot="{ item }">
                        <v-row class="ma-0 pa-0" align="center" style="height:44px;">
                          <template v-for="(header) in headers">
                            <v-col :cols="header.width" class="pa-0" :key="header.key">
                              <span>{{ item[header.key] }}</span>
                            </v-col>
                          </template>
                          <v-col cols="2" class="pa-0" align="center">
                            <v-btn small icon @click="removeDialog = true" class="ma-0">
                              <v-icon color="error">mdi-delete</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </template>
                    </RecycleScroller>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="8" class="py-0">
              <v-row class="ma-0 pa-0">
                <v-col cols="12" class="pa-0">
                  <v-toolbar flat class="b-B" height="40">
                    <v-toolbar-title class="text-left subheading">
                      <span>位置</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <div id="maps" :style="mapHeight"></div>
                </v-col>
              <v-col cols="12" class="pa-0">
                <v-row class="ma-0 pa-0" align="center">
                  <v-col cols="2" class="pa-0"></v-col>
                  <v-col cols="8" class="pa-0">
                    <v-text-field
                      ref="location"
                      prepend-icon="mdi-map-marker"
                      append-outer-icon="mdi-map-search"
                      label="場所"
                      v-model="myLocation"
                      clearable
                      @click:append-outer="onMapSearch()"
                      @click:clear="item = null"
                      @keyup.enter.native="onMapSearch()"
                    ></v-text-field>
                    </v-col>
                    <v-col cols="2" class="pa-0" align="center">
                      <v-btn rounded color="primary" depressed dark @click.native="onSubmitDialog()">{{ item ? '更新' : '登録' }}</v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <div>
      <app-basic-dialog
        v-if='removeDialog'
        @dismissed="onDismissed"
        :title="'地図'"
        :message="'位置情報を削除します。よろしいですか?'"
        :dialog='removeDialog'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import gmapsInit from '../../utils/gmaps'
import { mapGetters } from 'vuex'
export default {
  props: [ 'location', 'dialog', 'scopes', 'scope', 'local' ],
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      locations: 'locations/locations',
      windowSize: 'shared/windowSize'
    }),
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 40) + 'px;'
    },
    mapHeight () {
      return 'width: 100%; background: transparent; height: ' + String(this.windowSize.y - 60 - 40 - 70) + 'px;'
    }
  },
  data () {
    return {
      removeDialog: false,
      loading: false,
      google: null,
      geocoder: null,
      map: null,
      myLocation: null,
      geometry: null,
      item: null,
      school: null,
      headers: [
        { over: false, value: 0, title: '', key: 'name', width: '10' }
      ]
    }
  },
  created () {
    var index = this.locations.findIndex(loc => loc.key === this.location)
    if (index !== -1) {
      this.item = this.locations[index]
      this.myLocation = JSON.parse(JSON.stringify(this.locations[index].name))
    }
    var keys = Object.keys(this.data.schools)
    for (var i in keys) {
      if (this.data.schools[keys[i]]) {
        index = this.schools.findIndex(school => school.key === keys[i])
        if (index !== -1) {
          this.school = this.schools[index]
          if (!this.myLocation) {
            var address = this.schools[index].city + this.schools[index].address + this.schools[index].address2
            if (address) {
              this.myLocation = address
            } else {
              this.myLocation = 'フリーウィル学習塾'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.showMap()
  },
  methods: {
    async showMap () {
      try {
        this.google = await gmapsInit()
        this.geocoder = new this.google.maps.Geocoder()
        this.map = new this.google.maps.Map(document.getElementById('maps'))
        this.geocoder.geocode({ address: this.myLocation }, (results, status) => {
          if (status !== 'OK' || !results[0]) {
            throw new Error(status)
          }

          this.map.setCenter(results[0].geometry.location)
          this.map.fitBounds(results[0].geometry.viewport)
          this.geometry = results[0].geometry
          // eslint-disable-next-line
          var marker = new google.maps.Marker({
            position: this.map.getCenter(),
            map: this.map
          })
        })
      } catch (error) {
        console.error(error)
      }
    },
    onSelect (item) {
      this.item = JSON.parse(JSON.stringify(item))
      this.myLocation = item.name
      this.onMapSearch()
    },
    onMapSearch () {
      if (this.map && this.myLocation) {
        this.geocoder.geocode({ address: this.myLocation }, (results, status) => {
          if (status !== 'OK' || !results[0]) {
            throw new Error(status)
          }
          this.map.setCenter(results[0].geometry.location)
          this.geometry = results[0].geometry
          this.map.fitBounds(results[0].geometry.viewport)
          // eslint-disable-next-line
          var marker = new google.maps.Marker({
            position: this.map.getCenter(),
            map: this.map
          })
        })
      }
    },
    onSubmitDialog () {
      var vm = this
      if (this.geometry && this.myLocation) {
        this.loading = true
        var payload = this.item ? this.item : JSON.parse(JSON.stringify(this.$store.getters['locations/initial']))
        payload.name = this.myLocation
        payload.lat = this.geometry.location.lat()
        payload.lng = this.geometry.location.lng()
        if (!this.item) {
          payload.schools[this.school.key] = true
          payload.createdAt = parseInt(new Date().getTime())
        }
        payload.updatedAt = parseInt(new Date().getTime())
        this.$store.dispatch('locations/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
          vm.loading = false
          vm.item = null
          vm.$emit('dismissed', { name: this.myLocation, lat: this.geometry.location.lat(), lng: this.geometry.location.lng() })
        })
      } else {
        this.$emit('dismissed', { name: this.myLocation, lat: this.geometry.location.lat(), lng: this.geometry.location.lng() })
      }
    },
    onRemove () {
      var vm = this
      this.removeDialog = false
      this.$nextTick(function () {
        this.loading = true
        var payload = vm.item.key
        vm.$store.dispatch('locations/delete', payload).then(() => {
          vm.item = null
          vm.loading = false
        })
      })
    },
    onClose () {
      this.$emit('dismissed', null)
    },
    onDismissed: function (value) {
      if (this.removeDialog) {
        this.removeDialog = false
        if (value) {
          this.onRemove()
        }
      }
    }
  }
}
</script>

<style scoped>
.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
